<script setup lang="ts">
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
</script>


<template>
  <div>
    <IDSKParagraph class="zhrnutie-error-message" variant="large">
      <b>{{ t('globalne.zhrnutie-section-error') }}</b>
    </IDSKParagraph>
  </div>
</template>

<style lang="scss" scoped>
.zhrnutie-error-message {
  color: #d0190f;
}
</style>
